import React from 'react'

const DevicePageTop = ({
  crumbLabel,
  onBack,
  kind,
  title,
  isUp,
  isDown,
  downDuration,
  address,
  model,
  firmware,
  showDetails,
  onToggleDetails,
  onRefresh,
  refreshing,
  t,
}) => (
  <>
    <button
      type="button"
      onClick={onBack}
      className="inline-flex items-center gap-1 text-[11px] font-medium uppercase tracking-[0.08em] text-muted-500 transition hover:text-white"
    >
      <span className="material-icons text-[14px]">arrow_back</span>
      {crumbLabel}
    </button>

    <header className="-mt-3 flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
      <div className="min-w-0">
        {kind && (
          <p className="mb-1 text-[11px] font-medium uppercase tracking-[0.08em] text-muted-500">
            {kind}
          </p>
        )}
        <div className="flex flex-wrap items-center gap-3">
          <h1 className="font-display text-3xl text-white md:text-4xl">{title}</h1>
          <span className={`inline-flex items-center gap-1.5 text-sm ${isUp ? 'text-muted-300' : 'text-critical'}`}>
            <span className={`h-2 w-2 rounded-full ${isUp ? 'bg-positive' : isDown ? 'bg-critical' : 'bg-muted-500'}`} />
            {isUp
              ? t('common.online')
              : downDuration
                ? t('device.downFor', { duration: downDuration })
                : t('equipment.state.unavailable')}
          </span>
        </div>
        <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-muted-400">
          {address && <span className="font-mono tabular-nums text-muted-200">{address}</span>}
          {model && (
            <>
              <span className="text-muted-600">·</span>
              <span>{model}</span>
            </>
          )}
          {firmware && (
            <>
              <span className="text-muted-600">·</span>
              <span>{firmware}</span>
            </>
          )}
          <button
            type="button"
            onClick={onToggleDetails}
            className="ml-3 inline-flex items-center gap-1 text-muted-500 transition hover:text-white"
          >
            <span className="material-icons text-[16px]">{showDetails ? 'expand_less' : 'tune'}</span>
            {showDetails ? t('common.hide') : t('schoolDashboard.details')}
          </button>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-2">
        <button
          type="button"
          onClick={onRefresh}
          className="inline-flex items-center gap-2 rounded-xl bg-white/[0.04] px-4 py-2 text-sm text-muted-200 transition hover:bg-white/[0.08] hover:text-white"
        >
          <span className={`material-icons text-[18px] ${refreshing ? 'animate-spin' : ''}`}>refresh</span>
          {t('common.refresh')}
        </button>
      </div>
    </header>
  </>
)

export default DevicePageTop
